export enum EpisodeCreatedFrom {
    Other = 0,
    ConsultationHistory,
    WalkIn,
    Prescription,
    Form
}